import { memo } from "react";
import { Navigate } from "infrastructure/router";
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import type { WithApplication } from "../hooks";

type Props = WithApplication<{
    readonly prefix?: string;
}>;

const OnboardingInitialStepRedirect = ({ getApplicationModel, prefix = '' }: Props) => {
    const getRedirectStep = () => {
        for (const [step, {
            countable = true,
            isIncomplete,
            hasRequestedChange
        }] of Array.from(getApplicationModel())) {
            if (!countable) {
                continue;
            }

            if (isIncomplete || hasRequestedChange) {
                return step;
            }
        }

        return ECommerceOnboardingStep[ECommerceOnboarding.Merchant].BusinessInformation;
    };

    return (
        <Navigate
            to={`${prefix}${getRedirectStep()}`}
            replace
        />
    );
};

export default memo(OnboardingInitialStepRedirect);
